<section class="section-container">
  <div class="section-content">
    <app-alert class="alert" customIcon="info" [dense]="true" [type]="'brand'" title="Contrato: ">
      <strong>{{contract?.contrato || ''}}</strong>
    </app-alert>
    <div class="checkout-container">
      <div class="header">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.95435 20.6508L6.34546 17.0406H6.90906C7.27503 17.0424 7.63757 16.9713 7.97595 16.8318C8.31433 16.6923 8.622 16.4877 8.88049 16.2285L11.7449 13.3654C11.8456 13.2704 11.9776 13.2169 12.116 13.2169C12.2544 13.2169 12.3887 13.2704 12.4894 13.3654L15.3398 16.2169C15.5984 16.4771 15.9056 16.682 16.2444 16.8225C16.5832 16.963 16.9469 17.0345 17.3136 17.0336H17.6569L14.0341 20.6508C13.7664 20.9199 13.4475 21.1339 13.097 21.2796C12.7466 21.4253 12.3702 21.5 11.9907 21.5C11.6113 21.5 11.2348 21.4253 10.8844 21.2796C10.534 21.1339 10.2174 20.9199 9.94971 20.6508H9.95435ZM3.34424 14.036C2.80407 13.494 2.5 12.7595 2.5 11.9942C2.5 11.2289 2.80407 10.4944 3.34424 9.95244L5.54297 7.75986C5.58995 7.77648 5.63928 7.78622 5.68909 7.7877H6.90906C7.16525 7.78728 7.4191 7.83835 7.65588 7.93619C7.89267 8.03404 8.10786 8.1773 8.28906 8.35847L11.1511 11.2169C11.2771 11.3449 11.4283 11.445 11.5941 11.5139C11.7599 11.5829 11.9364 11.6192 12.116 11.6183C12.2963 11.6187 12.4758 11.5828 12.6425 11.5139C12.8092 11.445 12.9603 11.3446 13.0878 11.2169L15.9382 8.37007C16.1195 8.18802 16.3342 8.04414 16.5714 7.94548C16.8086 7.84682 17.0637 7.7972 17.3206 7.79698H18.3132C18.3658 7.79793 18.4179 7.78735 18.4663 7.76682L20.6511 9.95244C20.9202 10.22 21.134 10.537 21.2797 10.8875C21.4254 11.2379 21.5 11.6146 21.5 11.9942C21.5 12.3738 21.4254 12.7505 21.2797 13.1009C21.134 13.4514 20.9202 13.7684 20.6511 14.036L18.4663 16.2285C18.4184 16.2057 18.3663 16.1929 18.3132 16.1914H17.3206C17.0641 16.1923 16.8086 16.1429 16.5714 16.0452C16.3342 15.9476 16.1198 15.8042 15.9382 15.623L13.0878 12.7715C12.8269 12.5223 12.479 12.384 12.1183 12.384C11.7576 12.384 11.412 12.5223 11.1511 12.7715L8.28906 15.6299C8.10786 15.8111 7.89267 15.9544 7.65588 16.0522C7.4191 16.1501 7.16525 16.2011 6.90906 16.2007H5.68909C5.63844 16.2011 5.58847 16.2132 5.54297 16.2355L3.34424 14.036ZM11.7449 10.623L8.88049 7.77146C8.62226 7.51153 8.3143 7.30638 7.97595 7.16589C7.63761 7.02541 7.27539 6.95416 6.90906 6.95476H6.34546L9.95435 3.34455C10.4967 2.80433 11.23 2.5 11.9954 2.5C12.7607 2.5 13.4963 2.80433 14.0387 3.34455L17.6615 6.971H17.3182C16.952 6.96853 16.5878 7.03841 16.249 7.17749C15.9102 7.31657 15.6034 7.52166 15.3445 7.78074L12.494 10.6322C12.4461 10.6828 12.3887 10.7231 12.3247 10.7506C12.2607 10.7781 12.1926 10.7923 12.1229 10.7923C12.0533 10.7923 11.9828 10.7781 11.9188 10.7506C11.8548 10.7231 11.7974 10.6828 11.7495 10.6322L11.7449 10.623Z"
            fill="#575757" />
        </svg>
        <h2> Pix </h2>

        <strong *ngIf="(isMobileMatches | async).matches">{{installmentInvoice?.valorDocumento | currency:'BRL'}}</strong>
      </div>

      <div class="payment-container">
        <div class="payment-info-container">
          <h3>
            <span *ngIf="!(isMobileMatches | async).matches">Esse código</span>
            <span *ngIf="(isMobileMatches | async).matches">Código</span>
              expira em <strong>{{countdown || ''}} minutos</strong>
          </h3>

          <p>{{expirationDateMsg || ''}}</p>

          <div class="qr-code-container">
            <img class="qrcode" [src]="qrCodeURl" />
            <span class="code">{{pixPaymentData?.qrCode}}</span>
          </div>

          <button type="button" [disabled]="isExpired" (click)="copyPixCodeToClipboard()" class="copy-code-btn" mat-flat-button color="primary">
            <mat-icon>content_copy</mat-icon>
            <span>
              Copiar código
            </span>
          </button>

          <div *ngIf="!isExpired && statusPagamentoPix !== 'PAGO'" class="payment-status info">
            <div class="dot-loader"></div>
            <span>Aguardando pagamento do PIX.</span>
          </div>

          <div *ngIf="!isExpired && statusPagamentoPix === 'PAGO'" class="payment-status success">
            <mat-icon class="material-symbols-outlined mat-icon-error">info</mat-icon>
            <span>Seu código Pix foi pago! Lembre-se, a baixa da parcela pode levar até 24 horas.</span>
          </div>

          <div *ngIf="isExpired" class="payment-status error">
            <mat-icon class="material-symbols-outlined mat-icon-error">cancel</mat-icon>
            <span>O QR Code expirou. Por favor, gere um novo QR Code para realizar o pagamento.</span>
          </div>

          <hr *ngIf="(isMobileMatches | async).matches"  class="payment-resume-mobile-divider" />
        </div>

        <div class="payment-resume-info">
          <div class="resume">
            <div class="resume-item">
              <span>Parcela</span> <span class="total-installment"><strong>{{installment?.numeroParcela}}</strong>/{{contract?.parcelas?.length}}</span>
            </div>
            <hr />
            <div class="resume-item">
              <span>Valor Atualizado</span> <strong>{{installmentInvoice?.valorDocumento | currency:'BRL'}}</strong>
            </div>
            <hr />
          </div>

          <div class="payment-instructions">
            <span class="instruction">
              1. Acesse o app do banco, escolha a opção pagar com Pix e escaneie o QR Code;
            </span>
            <span class="instruction">
              2. Se preferir pagar pelo Internet Banking ou enviar para alguém: basta copiar o código Pix;
            </span>
            <span class="instruction">
              3. Após o pagamento, a confirmação irá aparecer nesta tela.
            </span>

            <hr />

            <span class="instruction"> <strong>Importante:</strong> Caso seu pagamento não seja efetivado até o prazo de expiração, este código será cancelado.</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="(isMobileMatches | async).matches" class="installment-info">
      <div class="resume-item">
        <span>Parcela</span> <span class="total-installment"><strong>{{installment?.numeroParcela}}</strong>/{{contract?.parcelas?.length}}</span>
      </div>
      <hr />
      <div class="resume-item">
        <span>Valor corrigido</span> <strong>{{installmentInvoice?.valorDocumento | currency:'BRL'}}</strong>
      </div>
    </div>
  </div>
</section>